import { Button, Group, Text, ThemeIcon } from "@mantine/core";

import { withPolymorphicClickAnalytics } from "@/analytics";
import { Plus } from "@/common-ui";

import noCallControlsClasses from "./NoCallControls.module.css";

interface NoActiveCallProps {
    onAddCall: () => void;
}

const NoCallControlsButton = withPolymorphicClickAnalytics(Button<"button">, "Click");

export function NoActiveCallControl({ onAddCall }: NoActiveCallProps) {
    return (
        <Group gap="xs" data-testid="no-active-call-controls">
            <Text size="sm" fw={"bold"} c="gray.7" onClick={onAddCall} flex={1}>
                No active call
            </Text>
            <Group gap="sm">
                <NoCallControlsButton
                    analytics={{
                        actionId: "NoCallControls_NewCallButton",
                    }}
                    classNames={{
                        section: noCallControlsClasses.newCallIcon,
                    }}
                    leftSection={
                        <ThemeIcon variant="transparent">
                            <Plus stroke="var(--mantine-color-gray-0)" width={13} />
                        </ThemeIcon>
                    }
                    onClick={onAddCall}
                    size="xs"
                    variant="filled"
                >
                    New
                </NoCallControlsButton>
            </Group>
        </Group>
    );
}
